module.exports = __webpack_public_path__ + "img/win.5aee6e20.png";